import React from "react";
import { Card, Badge, Button, Tooltip } from "antd";
import {
  EyeOutlined,
  EditOutlined,
  DeleteFilled,
  ShareAltOutlined,
} from "@ant-design/icons";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";

const FeedbackCard = ({
  form,
  isExample = false,
  onEdit,
  onDelete,
  onView,
  onShare,
}) => {
  const { language } = useLanguage();
  const text = dashboardContent[language].feedback.card;

  // Aktionen nur für reguläre Formulare
  const actions = [
    <Tooltip title={text.view} key="view">
      <Button
        type="text"
        icon={<EyeOutlined />}
        onClick={() => onView(form._id)}
      />
    </Tooltip>,
  ];

  if (!isExample) {
    actions.push(
      <Tooltip title={text.edit} key="edit">
        <Button
          type="text"
          icon={<EditOutlined />}
          onClick={() => onEdit(form._id)}
        />
      </Tooltip>,
      <Tooltip title={text.delete} key="delete">
        <Button
          type="text"
          icon={<DeleteFilled />}
          onClick={() => onDelete(form._id)}
        />
      </Tooltip>,
      <Tooltip title={text.share} key="share">
        <Button
          type="text"
          icon={<ShareAltOutlined />}
          onClick={() => onShare(form)}
        />
      </Tooltip>
    );
  }

  return (
    <Card
      className="h-[250px] flex flex-col justify-between"
      title={
        <Badge
          status={form.status === "active" ? "success" : "default"}
          text={form.name}
        />
      }
      hoverable
      style={{
        borderColor: form.status === "active" ? "#3f8600" : "#d9d9d9",
      }}
      actions={actions}
    >
      <div className="flex flex-col justify-between h-full">
        <p className="text-sm text-gray-600 mt-auto">
          <strong>{text.received}:</strong> {form.feedbackCount}
        </p>
      </div>
    </Card>
  );
};

export default FeedbackCard;
